export const THEME_COLOR_HEX = "#339933";
export const THEME_COLOR = "rgb(51, 153, 51)";
